import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Trump Kennedy Center · Elevate Your Experience</p>
        <h1>Welcome to the Trump Kennedy Center.</h1>
        <p className="lede">
          Discover a unique blend of culture, art, and community at the Trump Kennedy Center. 
          Join us in celebrating creativity and innovation in a vibrant environment.
        </p>
        <div className="cta-row">
          <a href="/events" target="_blank">
            Explore Upcoming Events
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Experience Art Like Never Before</h2>
          <p>
            Immerse yourself in captivating exhibitions and installations that inspire and engage.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow art enthusiasts and participate in workshops, discussions, and more.
          </p>
        </article>
        <article>
          <h2>Support Local Talent</h2>
          <p>
            Discover and uplift local artists through our programs and initiatives designed to foster creativity.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;